/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { updateURLRequestWithSecondaryAuthSupport } from 'blb-utils/secondaryAuth';
import styled from 'styled-components';
// The enableSecondaryAuth flag allows client (if logged in to secondary auth session) to pass in
// an additional query param so server knows it is from the secondary session (instead of reading from primary auth token)
// This is important for requests like download a file (e.g. api/loans/{uuid}/documents/{uuid}) because download requires authorization
// Otherwise client may receives 401 if primary session does not have authorization and secondary does
export const openUrlInNewTab = function (url) {
  let enableSecondaryAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (enableSecondaryAuth) {
    url = updateURLRequestWithSecondaryAuthSupport(url);
  }
  window.open(url, '_blank', 'noopener');
};
export const openUrlInSameTab = (url, enableSecondaryAuth) => {
  if (enableSecondaryAuth) {
    url = updateURLRequestWithSecondaryAuthSupport(url);
  }
  window.location.assign(url);
};
export const goBackToPipeline = history => {
  const previousUrl = window.document.referrer;
  const previousUrlComesFromBridge = previousUrl.includes('blend-bridge.sandbox.k8s.centrio.com/pipeline') || previousUrl.includes('workspace.blend.com/pipeline') || previousUrl.includes('workspace.beta.blend.com/pipeline') || previousUrl.includes('localhost:9050/pipeline');
  if (previousUrlComesFromBridge) {
    history.goBack();
  } else {
    history.push('/pipeline');
  }
};
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
export const styledAttrs = (component, attrs) => styled(component).attrs(attrs)``;